import { useContext, useState } from "react"
import { Modal } from "react-bootstrap"
import { Contexto } from "../Context/Contexto"
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion"
import { tokens } from "../Context/Tokens"
import { Get } from "../Rutas/ApiRest"
import { cuentaCliente } from "../Rutas/Servicios"


export function Casillas(dato:any)
{
    const {Cli}=useContext(Contexto)
    const {tok}=useContext(tokens)
    const {ActualizarCli}=useContext(Contexto)
    const {SetMensajeEmergente,SetLoading}=useContext(MensajeContActualizacion)
    const [activoMensaje,SetActivoMensaje]=useState<boolean>(false)
    const [activoMensaje2,SetActivoMensaje2]=useState<boolean>(false)
    const solicitarCasilla=()=>
    {
        const dato=Get(cuentaCliente.CrearEspana.replace("@rut",Cli.rut+"").replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
        dato.then(resultado=>
            {
                const datos=Get(cuentaCliente.DatosClientes.replace("@rut",Cli.rut),"application/json",tok)
                datos.then(resultado=>{ActualizarCli(resultado);SetLoading(false);SetMensajeEmergente("Tu casilla España ha sido Activada correctamente");})
            })
            
        
    }

    const desactivarCasilla=()=>
    {
        const dato=Get(cuentaCliente.EliminarEspana.replace("@rut",Cli.rut+"").replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
        dato.then(resultado=>
            {
                if(resultado.retorno==0)
                {
                    SetLoading(false);
                    SetMensajeEmergente(resultado.mensaje)
                }else
                {
                    SetMensajeEmergente(resultado.mensaje)
                     const datos=Get(cuentaCliente.DatosClientes.replace("@rut",Cli.rut),"application/json",tok)
                     datos.then(resultado=>{ActualizarCli(resultado);SetLoading(false);})
                }
                
            })
        

    }

    return (
        <>
        <div className="accordion-item">
                                    <h2 className="accordion-header" id={dato.dato.idHeading}>
                                    <button className={dato.dato.colapse} type="button" data-bs-toggle="collapse" data-bs-target={"#"+dato.dato.collapseId} aria-expanded={dato.dato.inicio} aria-controls={dato.dato.collapseId}> Casilla {dato.dato.casillaRegion} </button>
                                    </h2>
                                    {dato.estado?<div id={dato.dato.collapseId} className={dato.dato.casillaRegion=="España"?"accordion-collapse collapse":"accordion-collapse collapse show"} aria-labelledby={dato.dato.idHeading} data-bs-parent="#accordionTabla">
                                    <div className="accordion-body">
                                        <p>Tu Casilla {dato.dato.casillaRegion} Es: <strong className="text-warning">{Cli.lCasilla[Cli.Eleccion].ecode}</strong></p>
                                        <p>Tu dirección virtual para comprar en {dato.dato.casillaRegion=="Miami"?"USA":dato.dato.casillaRegion}:</p>
                                        <table className="table table-striped table-bordered" style={{width:"100%"}} cellSpacing="0" cellPadding="0">
                                            <tbody>
                                                <tr>
                                                    <td><strong>First name</strong></td>
                                                    <td><span id="">{Cli.nombre}</span></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Last Name</strong></td>
                                                    <td><span id="">{Cli.apellidoPaterno}</span></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Street Line 1</strong></td>
                                                    <td><span id="">{dato.dato.calle} {dato.dato.calle2==""?","+Cli.lCasilla[Cli.Eleccion].ecode:null}</span></td>
                                                </tr>
                                                {dato.dato.calle2!=""?<tr>
                                                    <td><strong>Street Line 2</strong></td>
                                                    <td><span id="">{dato.dato.calle2}</span> <span id="">{Cli.lCasilla[Cli.Eleccion].ecode}</span></td>
                                                </tr>:null}
                                                <tr>
                                                    <td><strong>ZipCode</strong></td>
                                                    <td><span id="">{dato.dato.zipCode}</span></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>City</strong></td>
                                                    <td><span id="">{dato.dato.ciudad}</span></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>State</strong></td>
                                                    <td><span id="">{dato.dato.state}</span></td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Telephone</strong></td>
                                                    <td><span id="">{dato.dato.telefono}</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        {dato.dato.casillaRegion=="España"?<div className="accordion-body">
                                    <button className="btn btn-success" style={{marginRight:"10px"}} onClick={()=>{SetActivoMensaje2(true)}} >
                                            Desactivar mi Casilla {dato.dato.casillaRegion}
                                                </button>
                                    </div>:null}
                                    </div>
                                   
                                    </div>:<div id={dato.dato.collapseId} className={dato.dato.casillaRegion=="España"?"accordion-collapse collapse":"accordion-collapse collapse show"} aria-labelledby={dato.dato.idHeading} data-bs-parent="#accordionTabla">
                                    <div className="accordion-body">
                                        <p>¿No tienes tu Casilla {dato.dato.casillaRegion}? </p>
                                        <div className="col-sm-6"> 
                                            <button className="btn btn-success" style={{marginRight:"10px"}} onClick={()=>{SetActivoMensaje(true)}} >
                                                Solicítala aquí
                                                </button>
                                            </div>
                                    </div>
                                    </div>}
                                </div>


                                <Modal show={activoMensaje} >
                                <Modal.Body style={{borderColor:"#bce8f1"}}>
            <div className="panel panel-info" style={{padding:"10px 15px",borderBottom:"1px solid trasparent",borderTopRightRadius:"3px",borderTopLeftRadius:"3px",color:"#31708f",backgroundColor:"#d9edf7",borderColor:"#bce8f1"}}>
                <label style={{display:"inline-block",marginBottom:"5px",fontWeight:"700"}}>
                    ¿Está seguro que Desea Activar su Casilla {dato.dato.casillaRegion}?
                </label>
            </div>
            
        </Modal.Body>
                                <Modal.Header style={{marginBottom:"20px",padding:"10px 15px",color:"#31708f",backgroundColor:"#fff",borderColor:"#bce8f1",border:"1px solid transparent",borderRadius:"4px",display:"block"}}>
            
            </Modal.Header >

           
       
        <Modal.Footer>
            <button className="btn btn-warning" onClick={()=>{solicitarCasilla();SetLoading(true);SetActivoMensaje(false)}}>Aceptar</button>
            <button className="btn btn-warning" onClick={()=>SetActivoMensaje(false)}>Cerrar</button>
        </Modal.Footer>
    </Modal>

    <Modal show={activoMensaje2} >
        
        <Modal.Body style={{borderColor:"#bce8f1"}}>
            <div className="panel panel-info" style={{padding:"10px 15px",borderBottom:"1px solid trasparent",borderTopRightRadius:"3px",borderTopLeftRadius:"3px",color:"#31708f",backgroundColor:"#d9edf7",borderColor:"#bce8f1"}}>
                <label style={{display:"inline-block",marginBottom:"5px",fontWeight:"700"}}>
                ¿Está seguro que Desea Desactivar su Casilla {dato.dato.casillaRegion}?
                </label>
            </div>
            </Modal.Body>
            <Modal.Header style={{marginBottom:"20px",padding:"10px 15px",color:"#31708f",backgroundColor:"#fff",borderColor:"#bce8f1",border:"1px solid transparent",borderRadius:"4px",display:"block"}}>
            
            </Modal.Header >
       
        <Modal.Footer>
            <button className="btn btn-warning" onClick={()=>{desactivarCasilla();SetLoading(true);SetActivoMensaje2(false)}}>Aceptar</button>
            <button className="btn btn-warning" onClick={()=>SetActivoMensaje2(false)}>Cerrar</button>
        </Modal.Footer>
    </Modal>
        </>

        
    )
}